module.exports = __webpack_public_path__ + "img/mo.db3f10ce.png";